var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7Ad387832D629A52C87195D9Cb795E3C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 8.258C10.277 8.258 12.129 6.406 12.129 4.13C12.129 1.853 10.277 0 7.99997 0C5.72297 0 3.87097 1.853 3.87097 4.13C3.87097 6.406 5.72297 8.258 7.99997 8.258ZM7.99997 2.42C8.94297 2.42 9.70897 3.187 9.70897 4.129C9.70897 5.071 8.94297 5.838 7.99997 5.838C7.05797 5.838 6.29097 5.071 6.29097 4.129C6.29097 3.187 7.05797 2.42 7.99997 2.42Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66998 11.6269C10.512 11.4349 11.322 11.1029 12.068 10.6339C12.632 10.2779 12.804 9.52995 12.447 8.96595C12.092 8.39995 11.345 8.22895 10.779 8.58595C9.08798 9.64895 6.90998 9.64895 5.21898 8.58595C4.65298 8.22995 3.90598 8.39995 3.55198 8.96595C3.19598 9.53195 3.36498 10.2779 3.93098 10.6339C4.67798 11.1029 5.48798 11.4349 6.32898 11.6269L4.01998 13.9359C3.54798 14.4079 3.54798 15.1739 4.01998 15.6459C4.25698 15.8819 4.56598 15.9999 4.87598 15.9999C5.18598 15.9999 5.49598 15.8819 5.73198 15.6459L7.99998 13.3769L10.27 15.6459C10.741 16.1189 11.508 16.1189 11.979 15.6459C12.454 15.1739 12.454 14.4079 11.979 13.9359L9.66998 11.6269Z",
    fill: "#F6F6F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Ad387832D629A52C87195D9Cb795E3C);
export default __webpack_public_path__ + "static/media/7ad387832d629a52c87195d9cb795e3c.cdacedd0e972f575b6dd1afbd7c93a25.svg";
export { ForwardRef as ReactComponent };